import {
  DocumentMagnifyingGlassIcon,
  DocumentMinusIcon,
} from "@heroicons/react/24/outline";
import { CreateCourseDTO } from "@tumtutor/shared/dto";
import { SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface CitationToggleProps {
  citationsEnabled: boolean;
  setCourse: (value: SetStateAction<CreateCourseDTO>) => void;
}

const CitationToggle = ({
  citationsEnabled,
  setCourse,
}: CitationToggleProps) => {
  const { t } = useTranslation(["courseManagementPage", "commons"]);
  const [citationToggle, setCitationToggle] = useState(false);

  useEffect(() => {
    setCitationToggle(citationsEnabled);
  }, [citationsEnabled]);
  return (
    <div>
      <span className="label-text font-semibold text-lg">{t("citation")}</span>

      <div className="my-sm">
        <div className="mb-sm flex flex-row items-center">
          <input
            type="checkbox"
            className="toggle mr-md"
            checked={citationToggle}
            onChange={(e) => {
              setCitationToggle(e.target.checked);

              setCourse((prev) => ({
                ...prev,
                citationsEnabled: e.target.checked,
              }));
            }}
          />
          {citationToggle ? (
            <DocumentMagnifyingGlassIcon className="h-6 w-6" />
          ) : (
            <DocumentMinusIcon className="h-6 w-6 opacity-50" />
          )}

          <p
            className={`ml-sm font-semibold text-lg ${!citationToggle ? "opacity-50" : ""}`}
          >
            {citationToggle
              ? t("enabled", { ns: "commons" })
              : t("disabled", { ns: "commons" })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CitationToggle;
